import { render, staticRenderFns } from "./FormErrors.vue?vue&type=template&id=20cae81d&scoped=true&"
var script = {}
import style0 from "./FormErrors.vue?vue&type=style&index=0&id=20cae81d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cae81d",
  null
  
)

export default component.exports